// extracted by mini-css-extract-plugin
export default {"next_order":"ax","recurringdis":"bx","reactivate_button":"cx","order__summary_title":"ex","order__summary_items":"fx","order__summary_item":"gx","order__summary_item_title":"hx","order__summary_item_quantity":"ix","order__item_separator":"jx","discount":"kx","promowrapper":"lx"};
    if(module.hot) {
      // 1726593103593
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  